<div class="title">
  <div class="mat-subheading-2 ">
    Download this experience
  </div>
  <div class="close" (click)="onClose()">
      <mat-icon>clear</mat-icon>
  </div>
</div>

<div  class="dialog-content">
  <div>
    <i>You are about to download a zip file containing all your media. Depending on your project, it can take long minutes.
    </i>
  </div>
  <div id="btn-container" [ngSwitch]="mode">
    <button *ngSwitchCase="'initializing'" mat-button [disabled]="true"><mat-icon class="rotating">settings</mat-icon> Initializing ...</button>
    <button *ngSwitchCase="'downloadready'" mat-button (click)="downloadBundle()"><mat-icon>archive</mat-icon> Start Download ({{ bundleSize | filesize }})</button>
    <button *ngSwitchCase="'downloadimpossible'" mat-button [disabled]="true"><mat-icon>error</mat-icon> This project contains medias which cannot be downloaded</button>
    <button *ngSwitchCase="'processing'" mat-button [disabled]="true"><mat-icon class="rotating">settings</mat-icon> Processing ...</button>
    <button *ngSwitchCase="'ended'" mat-button  (click)="launchDownload()"><mat-icon>settings</mat-icon> Your download should have started</button>
  </div>
</div>